import { render } from "./LoginAdmin.vue?vue&type=template&id=9bfd56c8&scoped=true"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"

import "./LoginAdmin.vue?vue&type=style&index=0&id=9bfd56c8&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfd56c8"]])

export default __exports__